module.exports = __webpack_public_path__ + "static/media/toggle-up.76435916.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/suttonparkbus/toggle-up.svg
// module id = 896
// module chunks = 0